export const companyInfo = {
  name: 'UC Advisors',
  legalEntity: 'UC Advisers LLC',
  tagline: 'Secure. Optimize. Transform.',
  description: 'UC Advisors holistically evaluates your organization—starting with cybersecurity—then optimizes your network, UCaaS, CCaaS, and operational processes to deliver measurable performance and cost improvements.',
  phone: '(916) 546-1008',
  phoneRaw: '9165461008',
  email: 'sales@ucadvisors.com',
  locations: [
    {
      city: 'Sacramento',
      state: 'CA',
      address: '3465 American River Dr',
      fullAddress: '3465 American River Dr, Sacramento, CA 95864, USA',
      isPrimary: true,
    },
    {
      city: 'Dallas',
      state: 'TX',
      address: '9540 Garland Road Suite 381',
      fullAddress: '9540 Garland Road Suite 381, Dallas, TX 75218',
      isPrimary: false,
    },
  ],
  hours: 'Monday - Friday: 6 AM - 6 PM PST',
  social: {
    facebook: 'https://facebook.com/ucadvisers',
    linkedin: 'https://linkedin.com/company/ucadvisers',
  },
  stats: [
    { value: '100+', label: 'Clients Served' },
    { value: '100%', label: 'Satisfied Customers' },
    { value: '30+', label: 'Years Combined Experience' },
  ],
  certifications: [
    {
      name: 'Zoom Certified Installer',
      description: 'Certified to install and configure Zoom communications solutions',
      logo: '/certifications/zoom-certified.svg',
    },
    {
      name: 'Zoom Support Specialist',
      description: 'Certified to provide ongoing support for Zoom platforms',
      logo: '/certifications/zoom-support.svg',
    },
  ],
}

export const testimonials = [
  {
    id: 1,
    quote: 'UC Advisors revolutionized our contact center operations with their innovative solutions. Their expertise in AI and workforce management helped us optimize staffing levels, improve agent productivity, and deliver exceptional customer service.',
    author: 'John Smith',
    title: 'VP of Operations',
    company: 'Regional Credit Union',
    rating: 5,
  },
  {
    id: 2,
    quote: "We've been working with UC Advisors for several years now, and their outsourcing and labor solutions have been instrumental in helping us scale our business. Their team has provided us with highly skilled professionals who seamlessly integrate into our workforce.",
    author: 'Emily Johnson',
    title: 'CTO',
    company: 'Community Bank',
    rating: 5,
  },
  {
    id: 3,
    quote: "UC Advisors' unified communications solutions have transformed the way our team collaborates and communicates. Their platform is intuitive, reliable, and feature-rich, making it easy for us to conduct virtual meetings and stay connected.",
    author: 'Michael Brown',
    title: 'IT Director',
    company: 'Financial Services Corp',
    rating: 5,
  },
  {
    id: 4,
    quote: 'As a rapidly growing startup, we needed scalable IT solutions that could adapt to our evolving needs. UC Advisors provided us with tailored IT services that have helped us stay agile, secure, and competitive.',
    author: 'Sarah Lee',
    title: 'CEO',
    company: 'FinTech Innovations',
    rating: 5,
  },
  {
    id: 5,
    quote: 'Working with UC Advisors has been a game-changer for our business. Their AI solutions have enabled us to automate routine tasks, analyze large datasets, and make data-driven decisions with confidence.',
    author: 'David Rodriguez',
    title: 'Director of Technology',
    company: 'Pacific Credit Union',
    rating: 5,
  },
]

export const whyChooseUs = [
  {
    title: 'Security-First Approach',
    description: "Every engagement starts with a comprehensive security assessment. We believe strong cybersecurity is the foundation upon which all other technology decisions should be made.",
  },
  {
    title: 'Provider Agnostic',
    description: "We are a technology broker agnostic to all service providers. This means our recommendations are strictly based on what's best for your business, not on hitting vendor quotas.",
  },
  {
    title: 'Holistic Optimization',
    description: "We don't sell isolated products—we optimize your entire technology stack. Security, network, communications, and customer experience are all interconnected.",
  },
  {
    title: 'Financial Services Experts',
    description: "With 30+ years of combined experience, our team specializes in the unique compliance and operational needs of Credit Unions, Banks, and Financial Institutions.",
  },
]

